import { InspectorControls, useBlockProps } from '@wordpress/block-editor';
import { Notice, PanelBody } from '@wordpress/components';
import { useEffect, useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import ServerSideRender from '@wordpress/server-side-render';
const { SelectControl } = wp.components;



export default function Edit(props) {
	const { attributes, setAttributes } = props;
	const { shortcode, preview } = attributes;
	const [error, setError] = useState(null);
	const postList = confirmation?.shortCodeList || [];
	const externalJS = confirmation?.loadScript;
	const blockProps = useBlockProps();

	useEffect(() => {
		let script;

		if (externalJS && shortcode && shortcode !== '0') {
			const timer = setTimeout(() => {
				const existingScript = document.querySelector(`script[src="${externalJS}"]`);
				if (existingScript) {
					document.body.removeChild(existingScript);
				}

				script = document.createElement('script');
				script.src = externalJS;
				script.async = true;
				document.body.appendChild(script);
			}, 1000);

			return () => {
				clearTimeout(timer);
				if (script) {
					document.body.removeChild(script);
				}
			};
		}
	}, [externalJS, shortcode]);

	return (
		<>
			<InspectorControls>
				<PanelBody title={__('Domain For Sale Settings', 'domain-for-sale')}>
					{error ? (
						<Notice status="error" isDismissible={false}>
							{error}
						</Notice>
					) : (
						<SelectControl
							label={__('Select Template', 'domain-for-sale')}
							value={shortcode || '0'}
							options={[
								{
									label: __('-- Select a view (shortcode) --', 'domain-for-sale'),
									value: '0',
								},
								...postList.map((post) => ({
									label: post.title,
									value: post.id.toString(),
								})),
							]}
							onChange={(newTemplate) => {
								setAttributes({ shortcode: newTemplate });
								setError(null); // Reset error on new selection
							}}
						/>
					)}
				</PanelBody>
			</InspectorControls>
			<div {...blockProps}>
				<div className="dfs_editor_template">
					{shortcode && shortcode !== '0' ? (
						<ServerSideRender
							block="create-block/domain-for-sale-template"
							attributes={attributes}
						/>
					) : (
						postList && postList.length > 0 ? (
							<SelectControl
								label={__('Select Template', 'domain-for-sale')}
								value={shortcode || '0'}
								options={[
									{
										label: __('-- Select a template (shortcode) --', 'domain-for-sale'),
										value: '0',
									},
									...postList.map((post) => ({
										label: post.title,
										value: post.id.toString(),
									})),
								]}
								onChange={(newTemplate) => {
									setAttributes({ shortcode: newTemplate });
									setError(null); // Reset error on new selection
								}}
							/>
						) : (
							<div className='dfs_template_placeholder'>
								<div className='dfs_template_placeholder_label'>
									<div className="dashicons dashicons-admin-site"></div>
									<h4>{__('Domain For Sale', 'domain-for-sale')}</h4>
								</div>
								{__('No template shortcode found.', 'domain-for-sale')} <a href={`post-new.php?post_type=dfs_template`} target="_blank" rel="noopener noreferrer">{__('Create a template now!', 'domain-for-sale')}</a>
							</div>
						)
					)}
				</div>
			</div>
		</>
	);
}